"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var system_1 = require("@mui/system");
var svgs_1 = require("../../../../assets/svgs");
var SideBarItem_1 = __importDefault(require("../SideBarItem/SideBarItem"));
function SideBar(_a) {
    var _b = _a.isDesktop, isDesktop = _b === void 0 ? false : _b, sideBarItems = _a.sideBarItems, _c = _a.collapsed, collapsed = _c === void 0 ? false : _c, _d = _a.style, style = _d === void 0 ? {} : _d;
    return ((0, jsx_runtime_1.jsxs)(system_1.Box, __assign({ sx: __assign({ backgroundColor: 'primary.700', height: '100%', boxSizing: 'border-box', width: collapsed
                ? '7.2rem'
                : style.width
                    ? style.width
                    : isDesktop
                        ? '18rem'
                        : '25.0rem', borderRadius: '0px', borderColor: 'primary.300', borderWidth: '0 1px 0 0', borderStyle: 'solid' }, style) }, { children: [(0, jsx_runtime_1.jsx)(system_1.Box, __assign({ sx: __assign({ paddingLeft: isDesktop ? '2.4rem' : '4.0rem', paddingTop: isDesktop ? '3.2rem' : '5.6rem', paddingBottom: isDesktop ? '3.8rem' : '4.8rem' }, (collapsed
                    ? {
                        paddingLeft: 0,
                        paddingBottom: '4.3rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }
                    : null)) }, { children: collapsed ? ((0, jsx_runtime_1.jsx)(svgs_1.ElphaLogoSvg, { className: "side-bar-elpha-logo", width: isDesktop ? '37px' : '50px', height: isDesktop ? '37px' : '50px', viewBox: "0 0 85 80" })) : ((0, jsx_runtime_1.jsx)(svgs_1.LogoSvg, { className: "side-bar-elpha-text-logo", styles: {
                        display: collapsed ? 'none' : 'block',
                    }, width: isDesktop ? '80px' : '122px', height: isDesktop ? '36px' : '56px' })) })), sideBarItems.map(function (item) { return ((0, jsx_runtime_1.jsx)(SideBarItem_1.default, { title: item.title, icon: item.icon, onClick: item.onClick, isSelected: item.isSelected, "data-cy": item['data-cy'], isDesktop: isDesktop, collapsed: collapsed }, item.title)); })] })));
}
exports.default = SideBar;
